import { Instagram, MessageCircle } from "lucide-react";

function TikTokIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
  );
}

export default function HeaderSocials() {
  const linkClass =
    "rounded-md p-2 text-gray-200 transition-colors duration-200 " +
    "hover:bg-white/10 hover:text-orange-400";

  return (
    <div className="flex items-center gap-1" data-testid="header-social-links">
      <a
        href="https://t.me/cimmodua"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Telegram"
        className={linkClass}
        data-testid="header-telegram-link"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href="https://www.instagram.com/cimmodua/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className={linkClass}
        data-testid="header-instagram-link"
      >
        <Instagram className="h-5 w-5" />
      </a>
      <a
        href="https://www.tiktok.com/@cimm.od.ua"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        className={linkClass}
        data-testid="header-tiktok-link"
      >
        <TikTokIcon className="h-5 w-5" />
      </a>
    </div>
  );
}